import { tableSchema } from '@nozbe/watermelondb'


export const shoppingOrganizationSchema = tableSchema({
  name: 'shoppingOrganization',
  columns: [
    { name: 'shoppingOrganizationId', type: 'string' },
    { name: 'addressComplement', type: 'string' },
    { name: 'city', type: 'string' },
    { name: 'companyDocument', type: 'string' },
    { name: 'companyName', type: 'string' },
    { name: 'country', type: 'string' },
    { name: 'createdAt', type: 'string' },
    { name: 'district', type: 'string' },
    { name: 'isSubsidiary', type: 'boolean' },
    { name: 'nfe', type: 'boolean' },
    { name: 'number', type: 'string' },
    { name: 'organizationId', type: 'string' },
    { name: 'postalCode', type: 'string' },
    { name: 'state', type: 'string' },
    { name: 'stateRegistration', type: 'string' },
    { name: 'street', type: 'string' },
    { name: 'tradeName', type: 'string' },
    { name: 'updatedAt', type: 'string' },
    { name: 'type', type: 'number' }
  ]
})
